<template>
  <v-layout row wrap>
    <v-flex :key="0" v-if="e1Flag" xs12 md6 lg4 class="elevation-2">
      <v-layout row wrap justify-center>
        <v-slide-x-transition mode="out-in">
          <v-flex xs12 sm8 :key="1" v-if="!flags.editDoor">
            <h4 class="mb-3">Ubicación de las puertas</h4>
            <v-layout v-show="markers.length === 0" row wrap justify-end fill-height align-center>
              <v-flex
                xs12
                sm12
                md12
                class="text-xs-left"
                style="display: flex; align-items: center"
              >
                <div
                  class="mr-3"
                  :style="{
                    padding: '3px 3px 3px 3px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '30px',
                    backgroundColor: '#F6ECFF',
                    borderRadius: '0.5rem',
                  }"
                >
                  <v-icon
                    color="#512E6F"
                    style="padding: 0px; margin: 0px"
                    small
                    >speaker_notes</v-icon
                  >
                </div>
                <div>
                  <h4 style="color: #6b7280">
                    Registra al menos una puerta de salida del colegio.
                  </h4>
                </div>
              </v-flex>
            </v-layout>

            <!-- <h3 style="color:#6B7280;" class="text-left ml-2">
                  </h3> -->
            <v-slide-y-transition
              class="two-line subheader dooScroll scrollDesign pa-1"
              group
              tag="v-list"
            >
              <v-subheader key="subheader"
                >{{
                  markers.length === 0 ? '' : markers.length
                }}
                Puertas</v-subheader
              >
              <v-list-tile
                v-for="(item, index) in markers"
                :key="item.doorName"
                avatar
                ripple
                class="pa-2 mb-3 elevation-1 grey lighten-5"
                style="border-radius: 5px"
              >
                <v-list-tile-avatar>
                  <img :src="require('@/assets/panel/toolbar/door.png')" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.doorName }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ item.street }}
                    <br />
                    {{ item.type | filterTypeDoor }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple @click="selectDoor(item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn icon ripple @click="deleteDoor(item)">
                    <v-icon color="red lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-slide-y-transition>
            <!-- <v-btn @click="createDoor" round dark block color="gradiente">Agregar puertas</v-btn> -->

            <v-layout row wrap justify-center>
              <v-flex xs12 sm12 class="text-xs-center">
                <v-btn
                  class="btn__addDoor"
                  style="
                    font-size: 14px;
                    border-radius: 5px;
                    background: #f44336;
                    text-transform: inherit;
                    color: #fff;
                  "
                  @click="createDoor"
                  depressed
                  >Agregar puertas</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm8 :key="2" v-if="flags.editDoor">
            <v-form lazy-validation @submit.prevent="processForm">
              <v-container>
                <v-layout row wrap>
                  <!-- <h3 style="color:#6B7280;" class="text-left ml-4 mb-3">
                    Registra al menos una puerta de salida del colegio.
                  </h3> -->
                  <v-flex
                    xs12
                    sm12
                    md12
                    class="text-xs-left"
                    style="display: flex; align-items: center"
                  >
                    <div
                      class="mr-3"
                      :style="{
                        padding: '3px 3px 3px 3px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '30px',
                        backgroundColor: '#F6ECFF',
                        borderRadius: '0.5rem',
                      }"
                    >
                      <v-icon
                        color="#512E6F"
                        style="padding: 0px; margin: 0px"
                        small
                        >speaker_notes</v-icon
                      >
                    </div>
                    <div>
                      <h4 style="color: #6b7280">
                        Registra al menos una puerta de salida del colegio.
                      </h4>
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <h4 style="color: #374151; font-weight: 500">
                      Nombre de la puerta
                    </h4>
                    <v-text-field
                      v-model="doorForm.doorName"
                      @blur="$v.doorForm.doorName.$touch()"
                      required
                      outline
                      height="38px"
                      :error-messages="processErrorName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <h4 style="color: #374151; font-weight: 500">
                      Calle de referencia
                    </h4>
                    <v-text-field
                      v-model="doorForm.street"
                      @blur="$v.doorForm.street.$touch()"
                      required
                      outline
                      height="38px"
                      :error-messages="processErrorStreet"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <h4 style="color: #374151; font-weight: 500">
                      Tipo de puerta
                    </h4>
                    <v-select
                      :items="typeDoors"
                      item-text="text"
                      height="38px"
                      item-value="value"
                      v-model="doorForm.type"
                      @blur="$v.doorForm.type.$touch()"
                      outline
                      :error-messages="processErrorType"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 class="text-xs-center">
                    <!-- <v-btn @click="cancelDoor" round>Cancelar</v-btn> -->
                    <v-btn
                      class="btn__next"
                      style="
                        font-size: 14px;
                        border-radius: 5px;
                        border: 1px solid #e5e7eb;
                        background: #fff;
                        text-transform: inherit;
                        color: #374151;
                      "
                      @click="cancelDoor"
                      depressed
                      >Cancelar</v-btn
                    >
                  </v-flex>
                  <v-flex xs12 sm6 class="text-xs-center">
                    <!-- <v-btn class="gradiente white--text" round type="submit">Guardar</v-btn> -->
                    <v-btn
                      class="btn__next"
                      style="
                        font-size: 14px;
                        border-radius: 5px;
                        border: 1px solid #e5e7eb;
                        background: #fff;
                        text-transform: inherit;
                        color: #374151;
                      "
                      type="submit"
                      depressed
                      >Guardar</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-flex>
        </v-slide-x-transition>
      </v-layout>
    </v-flex>
    <v-flex xs12 :md6="e1Flag" :lg8="e1Flag">
      <GmapMap
        :center="{ lat: 19.702559, lng: -101.192341 }"
        :zoom="20"
        ref="mapBoarding"
        style="height: 700px; margin: 0px"
        :options="mapConfig"
        @zoom_changed="zoomChanged"
      >
        <GmapMarker
          :animation="2"
          :key="m.id"
          v-for="(m, index) in markers"
          :position="{ lat: m.latitude, lng: m.longitude }"
          :clickable="true"
          :draggable="
            (!flags.editDoor || m.index == doorForm.index) && !flags.addDoor
          "
          :title="m.doorName"
          :label="m.doorName"
          :icon="markerDoorIcon"
          @dragend="markerLocation($event, m)"
        />
        <GmapMarker
          :animation="2"
          :key="m.id"
          v-for="(m, index) in newMarkers"
          :position="{ lat: m.latitude, lng: m.longitude }"
          :clickable="true"
          :draggable="true"
          :title="m.doorName"
          :label="m.doorName"
          :icon="markerDoorIcon"
          @dragend="newMarkerLocation($event, m)"
        />

        <v-toolbar
          dense
          color="transparent"
          floating
          id="toolbarBoarding"
          class="titleSearch elevation-0"
        >
          <v-text-field
            class="mx-3 mt-4"
            @keyup.enter="searchName"
            label="Buscar"
            prepend-inner-icon="search"
            clearable
            solo
            v-model="search"
          ></v-text-field>
        </v-toolbar>
      </GmapMap>
    </v-flex>
    <info v-model="flags.info" text="No se encontraron resultados"></info>
  </v-layout>
</template>

<script>
import { mapSettings } from '@/Catalogs/mapSettings'
import { gmapApi } from 'vue2-google-maps'
import { required } from 'vuelidate/lib/validators'
import info from '../../Dialogs/Info'
export default {
  props: ['e1Flag', 'fSearch'],
  components: {
    info,
  },
  watch: {
    fSearch() {
      if (this.google) {
        this.search = this.fSearch
        this.searchName()
      }
    },
    markers() {
      this.$emit('doors', this.markers)
    },
  },
  mounted() {
    var v = this
    this.$refs.mapBoarding.$mapPromise.then((map) => {
      v.map = map
      var input = document.getElementById('toolbarBoarding')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_CENTER].push(input)
    })
  },
  validations: {
    doorForm: {
      doorName: { required },
      street: { required },
      type: { required },
    },
  },
  data: () => ({
    map: null,
    branch: {},
    markers: [],
    newMarkers: [],
    flags: {
      editDoor: false,
      addDoor: false,
      info: false,
    },
    search: '',
    doorForm: {
      doorName: '',
      street: '',
      type: '',
      longitude: '',
      latitude: '',
    },
    typeDoors: [
      {
        text: 'Mixto',
        value: 'M',
      },
      {
        text: 'Caminando',
        value: 'W',
      },
      {
        text: 'Carro',
        value: 'C',
      },
    ],
  }),
  filters: {
    filterTypeDoor(value) {
      switch (value) {
        case 'M':
          return 'Mixto'
        case 'C':
          return 'Carro'
        case 'W':
          return 'Caminando'
      }
    },
  },
  methods: {
    zoomChanged(event) {
      this.$emit('zoom', event)
    },
    selectDoor(door) {
      this.doorForm = door
      this.flags.editDoor = true
    },
    deleteDoor(door) {
      this.markers.splice(this.markers.indexOf(door), 1)
    },
    markerLocation(event, marker) {
      this.doorForm = marker
      this.flags.editDoor = true
      this.doorForm.latitude = event.latLng.lat()
      this.doorForm.longitude = event.latLng.lng()
    },
    newMarkerLocation(event, marker) {
      this.doorForm.latitude = event.latLng.lat()
      this.doorForm.longitude = event.latLng.lng()
    },
    createDoor() {
      this.flags.editDoor = true
      this.flags.addDoor = true
      var nDoor = {
        index: '',
        doorName: '',
        type: '',
        street: '',
        longitude: this.branch.markLongitude,
        latitude: this.branch.markLatitude,
      }
      this.newMarkers.push(nDoor)
      this.doorForm = nDoor
    },
    processForm() {
      this.$v.doorForm.$touch()
      if (!this.$v.doorForm.$invalid) {
        if (this.flags.addDoor) {
          this.addDoor()
        } else {
          this.doorForm = {
            index: '',
            doorName: '',
            street: '',
            type: '',
            longitude: '',
            latitude: '',
          }
          this.flags.editDoor = false
          this.$v.doorForm.$reset()
        }
      }
    },
    addDoor() {
      this.flags.editDoor = false
      this.flags.addDoor = false
      this.doorForm = {
        index: '',
        doorName: '',
        street: '',
        type: '',
        longitude: '',
        latitude: '',
      }
      this.$v.doorForm.$reset()
      this.newMarkers[0].index = this.markers.length
      this.markers.push(this.newMarkers[0])
      this.newMarkers = []
    },
    cancelDoor() {
      this.doorForm = {
        index: '',
        doorName: '',
        street: '',
        type: '',
        longitude: '',
        latitude: '',
      }
      this.flags.addDoor = false
      this.flags.editDoor = false
      this.newMarkers = []
    },
    searchName() {
      this.markers = []
      var v = this
      var request = {
        query: this.search,
        fields: ['name', 'geometry', 'formatted_address'],
      }
      var service = new google.maps.places.PlacesService(this.map)

      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var position = new google.maps.LatLng(
            results[0].geometry.location.lat(),
            results[0].geometry.location.lng()
          )
          v.branch = {
            markLongitude: results[0].geometry.location.lng(),
            markLatitude: results[0].geometry.location.lat(),
            address: results[0].formatted_address,
          }
          v.$store
            .dispatch('timeZoneAPI', {
              latitude: v.branch.markLatitude,
              longitude: v.branch.markLongitude,
            })
            .then((response) => {
              if (response.data.status == 'OK') {
                v.$emit('timeZone', response.data.timeZoneId)
              }
            })
            .catch((error) => {
              console.log(error)
            })
          var marker = new google.maps.Marker({
            map: v.map,
            icon: v.markerBranchIcon,
            position: position,
          })
          var infowindow = new google.maps.InfoWindow()
          v.map.setCenter(position)
          v.map.setZoom(18)
          infowindow.setContent(
            '<b>' +
              results[0].name +
              '</b><br>' +
              results[0].formatted_address +
              '<br>' +
              '<p>Si no encuentras la institución, puedes utilizar la barra de búsqueda para encontrar la dirección</p>'
          )
          v.$emit('inputBranch', v.branch)

          infowindow.open(v.map, marker)
        } else {
          v.flags.info = true
          v.$emit('inputBranch', {})
        }
      })
    },
  },
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings,
      }
    },
    markerDoorIcon() {
      return {
        url: require('@/assets/mapIcons/if_map-marker_3688470.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },
    markerBranchIcon() {
      return {
        url: require('@/assets/mapIcons/if_graduation-cap_3688484.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },
    processErrorName() {
      const errors = []
      if (!this.$v.doorForm.doorName.$dirty) return errors
      !this.$v.doorForm.doorName.required &&
        errors.push('El nombre de la puerta es requerido')
      return errors
    },
    processErrorStreet() {
      const errors = []
      if (!this.$v.doorForm.street.$dirty) return errors
      !this.$v.doorForm.street.required &&
        errors.push('La calle aledaña de la puerta es requerida')
      return errors
    },
    processErrorType() {
      const errors = []
      if (!this.$v.doorForm.type.$dirty) return errors
      !this.$v.doorForm.type.required &&
        errors.push('El tipo de puerta es requerido')
      return errors
    },
  },
}
</script>

<style scoped>
.btn__next {
  border-radius: 1rem;
  background: white !important;
  color: #374151;
  border: 1px solid #d1d5db !important;
}

.dooScroll {
  max-height: 500px;
  overflow-y: auto;
}
.btn__addDoor {
  border-radius: 1rem;
  background: #ef565c !important;
  color: #fff;
}
>>> .v-input__slot {
  border-color: #d1d5db !important;
  border-radius: 10px !important;
}
>>> .v-text-field--box input,
.v-text-field--full-width input,
.v-text-field--outline input {
  margin-top: 0px !important;
}
>>> .v-text-field--outline .v-text-field__prefix {
  margin-top: 0px !important;
}
>>> .v-select.v-text-field--enclosed:not(.v-text-field--single-line)
  .v-select__selections {
  padding-top: 0px !important;
}
>>> .v-text-field .v-input__append-inner,
.v-text-field .v-input__prepend-inner {
  align-self: center !important;
}
>>> .v-text-field .v-input__append-inner,
.v-text-field .v-input__prepend-inner {
  margin-top: 0px !important;
}
</style>
